<template>
  <div class="home">
    <!-- 产品海报区 -->
    <section class="hero-section">
      <div class="container">
        <div class="hero-content">
          <h1 class="product-name">RippleX 涟漪</h1>
          <p class="slogan">数字员工协作服务平台</p>
          <p class="description">
            让AI数字员工像涟漪一样扩散协作，高效完成各类工作任务，<br />
            为企业打造智能化、自动化的工作协作体系。
          </p>
          <div class="hero-buttons">
            <el-button type="primary" size="large" class="hero-btn primary">开始使用</el-button>
            <el-button size="large" class="hero-btn" @click="scrollToFeatures">了解更多</el-button>
          </div>
        </div>
        <div class="hero-image">
          <div class="hero-graphic">
            <div class="ripple ripple-1"></div>
            <div class="ripple ripple-2"></div>
            <div class="ripple ripple-3"></div>
            <div class="center-node"></div>
          </div>
        </div>
      </div>
    </section>

    <!-- 核心特性区 -->
    <section class="features-section" id="features">
      <div class="container">
        <h2 class="section-title">核心特性</h2>
        <div class="features-grid">
          <div class="feature-card" v-for="feature in features" :key="feature.id">
            <div class="feature-icon" :style="{ backgroundColor: feature.color }">
              <i :class="feature.icon"></i>
            </div>
            <h3 class="feature-title">{{ feature.title }}</h3>
            <p class="feature-desc">{{ feature.description }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 应用场景示例 -->
    <section class="scenarios-section" id="scenarios">
      <div class="container">
        <h2 class="section-title">应用场景</h2>
        <div class="scenarios-list">
          <div class="scenario-item" v-for="(scenario, index) in scenarios" :key="index">
            <div class="scenario-content" :class="[index % 2 === 0 ? 'left' : 'right']">
              <h3 class="scenario-title">{{ scenario.title }}</h3>
              <ul class="scenario-points">
                <li v-for="point in scenario.points" :key="point">{{ point }}</li>
              </ul>
            </div>
            <div class="scenario-image">
              <div class="placeholder-thumb" :style="{ backgroundColor: scenario.color }">
                <i :class="scenario.icon"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 发展路线图时间轴 -->
    <section class="roadmap-section" id="roadmap">
      <div class="container">
        <h2 class="section-title">发展路线图</h2>
        <div class="timeline">
          <div class="timeline-item" v-for="(item, index) in roadmap" :key="index">
            <div class="timeline-dot"></div>
            <div class="timeline-content" :class="[index % 2 === 0 ? 'left' : 'right']">
              <div class="timeline-date">{{ item.date }}</div>
              <h3 class="timeline-title">{{ item.title }}</h3>
              <p class="timeline-desc">{{ item.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 底部CTA区 -->
    <section class="cta-section">
      <div class="container">
        <h2 class="cta-title">Ready to get started?</h2>
        <p class="cta-desc">立即体验RippleX，开启AI数字员工协作新时代</p>
        <div class="cta-buttons">
          <a href="/docs" target="_blank" class="cta-btn docs">
            <i class="el-icon-document"></i> 查看文档
          </a>
          <a href="mailto:contact@guodong.tech" class="cta-btn contact">
            <i class="el-icon-message"></i> 联系我们
          </a>
        </div>
      </div>
    </section>

    <!-- 底部Footer -->
    <footer class="home-footer">
      <div class="container">
        <div class="footer-content">
          <div class="footer-info">
            <h3>RippleX 涟漪</h3>
            <p>数字员工协作服务平台</p>
          </div>
          <div class="footer-links">
            <div class="link-group">
              <h4>产品</h4>
              <a href="#features">功能特性</a>
              <a href="#scenarios">应用场景</a>
              <a href="#roadmap">发展路线</a>
            </div>
            <div class="link-group">
              <h4>资源</h4>
              <a href="/docs">文档中心</a>
              <a href="/api">API参考</a>
              <a href="/blog">技术博客</a>
            </div>
            <div class="link-group">
              <h4>公司</h4>
              <a href="/about">关于我们</a>
              <a href="mailto:contact@guodong.tech">联系我们</a>
              <a href="/jobs">加入我们</a>
            </div>
          </div>
        </div>
        <div class="footer-bottom">
          <p>© 2026 果动数智科技. All Rights Reserved.</p>
          <p><a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" style="color: #909399; text-decoration: none;">京ICP备18017034号-2</a></p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      features: [
        {
          id: 1,
          title: '智能协作',
          icon: 'el-icon-connection',
          color: '#409EFF',
          description: '多数字员工协同工作，分工完成复杂任务，提升工作效率'
        },
        {
          id: 2,
          title: '任务编排',
          icon: 'el-icon-s-operation',
          color: '#67C23A',
          description: '可视化任务流程编排，灵活定义工作步骤，快速响应业务变化'
        },
        {
          id: 3,
          title: '实时监控',
          icon: 'el-icon-data-analysis',
          color: '#E6A23C',
          description: '任务执行全程监控，状态实时推送，随时掌握工作进展'
        },
        {
          id: 4,
          title: '开放API',
          icon: 'el-icon-key',
          color: '#F56C6C',
          description: '完善的API接口设计，轻松集成到现有系统，扩展能力无限'
        },
        {
          id: 5,
          title: '安全可靠',
          icon: 'el-icon-lock',
          color: '#909399',
          description: '企业级安全防护，数据加密传输，保障信息安全'
        },
        {
          id: 6,
          title: '弹性扩展',
          icon: 'el-icon-expand',
          color: '#9B59B6',
          description: '按需扩展能力，随业务增长弹性扩容，降低使用成本'
        }
      ],
      scenarios: [
        {
          title: '客户服务自动化',
          icon: 'el-icon-service',
          color: '#409EFF',
          points: [
            '自动回复客户咨询，提升响应速度',
            '智能分类客户问题，分配给对应数字员工处理',
            '历史对话记录归档，方便后续查询分析'
          ]
        },
        {
          title: '数据处理与分析',
          icon: 'el-icon-data-board',
          color: '#67C23A',
          points: [
            '批量处理各类数据文件，自动清洗转换',
            '智能分析数据，生成可视化报表',
            '异常数据自动检测，提前预警'
          ]
        },
        {
          title: '内容生成与整理',
          icon: 'el-icon-document-copy',
          color: '#E6A23C',
          points: [
            '自动生成各类文档、报告、邮件',
            '整理会议纪要，提取关键信息',
            '内容审核，保证质量合规'
          ]
        },
        {
          title: '项目管理协作',
          icon: 'el-icon-s-grid',
          color: '#F56C6C',
          points: [
            '自动跟踪项目进度，更新任务状态',
            '定期生成项目汇报，同步给相关人员',
            '风险识别与预警，保障项目按时交付'
          ]
        }
      ],
      roadmap: [
        {
          date: '2026 Q1',
          title: 'MVP版本发布',
          description: '基础功能框架，支持数字员工基本协作，核心任务流程编排'
        },
        {
          date: '2026 Q2',
          title: '平台化扩展',
          description: '增加更多数字员工角色，支持自定义步骤模板，完善API接口'
        },
        {
          date: '2026 Q3',
          title: '性能优化',
          description: '提升并发处理能力，优化响应速度，支持大规模部署'
        },
        {
          date: '2026 Q4',
          title: '生态建设',
          description: '开放应用市场，支持第三方数字员工接入，构建完整生态'
        }
      ]
    }
  },
  methods: {
    scrollToFeatures() {
      const el = document.getElementById('features')
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  background-color: var(--bg-card);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 英雄区 */
.hero-section {
  min-height: 100vh;
  background: linear-gradient(135deg, var(--primary-color) 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  padding: 60px 0;

  .container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
  }
}

.hero-content {
  flex: 1;
  min-width: 350px;
  padding-right: 40px;
}

.product-name {
  font-size: 64px;
  font-weight: bold;
  color: var(--bg-card);
  margin: 0 0 16px;
  letter-spacing: 2px;
  white-space: nowrap;
  word-break: keep-all;
}

.slogan {
  font-size: 28px;
  color: rgba(255, 255, 255, 0.9);
  margin: 0 0 24px;
  font-weight: 300;
}

.description {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.8;
  margin: 0 0 40px;
}

.hero-buttons {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.hero-btn {
  padding: 12px 32px;
  font-size: 16px;

  &.primary {
    background-color: var(--bg-card);
    color: var(--primary-color);
    border-color: var(--bg-card);

    &:hover {
      background-color: rgba(255, 255, 255, 0.9);
      color: var(--primary-color);
    }
  }

  &:not(.primary) {
    background-color: transparent;
    color: var(--bg-card);
    border-color: rgba(255, 255, 255, 0.6);

    &:hover {
      background-color: rgba(255, 255, 255, 0.1);
      color: var(--bg-card);
    }
  }
}

.hero-image {
  flex: 1;
  min-width: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.hero-graphic {
  position: relative;
  width: 300px;
  height: 300px;
}

.ripple {
  position: absolute;
  border: 2px solid rgba(255, 255, 255, 0.6);
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation: ripple 3s infinite ease-out;

  &-1 {
    width: 60px;
    height: 60px;
  }

  &-2 {
    width: 140px;
    height: 140px;
    animation-delay: 1s;
  }

  &-3 {
    width: 220px;
    height: 220px;
    animation-delay: 2s;
  }
}

.center-node {
  position: absolute;
  width: 30px;
  height: 30px;
  background: var(--bg-card);
  border-radius: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0 0 20px rgba(255, 255, 255, 0.8);
}

@keyframes ripple {
  0% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(0);
  }
  100% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(1);
  }
}

/* 特性区 */
.features-section {
  padding: 100px 0;
  background-color: var(--bg-page);
}

.section-title {
  text-align: center;
  font-size: 36px;
  font-weight: bold;
  color: var(--text-primary);
  margin: 0 0 60px;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
}

.feature-card {
  background-color: var(--bg-card);
  padding: 30px;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  transition: transform 0.3s, box-shadow 0.3s;

  &:hover {
    transform: translateY(-5px);
    box-shadow: var(--shadow-lg);
  }
}

.feature-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;

  i {
    font-size: 28px;
    color: var(--bg-card);
  }
}

.feature-title {
  font-size: 20px;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 12px;
}

.feature-desc {
  font-size: 14px;
  color: var(--text-secondary);
  line-height: 1.7;
  margin: 0;
}

/* 应用场景 */
.scenarios-section {
  padding: 100px 0;
  background-color: var(--bg-card);
}

.scenarios-list {
  display: flex;
  flex-direction: column;
  gap: 60px;
}

.scenario-item {
  display: flex;
  align-items: center;
  gap: 40px;

  &.left {
    .scenario-content {
      order: 1;
    }
    .scenario-image {
      order: 2;
    }
  }

  &.right {
    .scenario-content {
      order: 2;
    }
    .scenario-image {
      order: 1;
    }
  }
}

.scenario-content {
  flex: 1;
}

.scenario-title {
  font-size: 24px;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 16px;
}

.scenario-points {
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    font-size: 15px;
    color: var(--text-secondary);
    line-height: 1.8;
    padding-left: 20px;
    position: relative;
    margin-bottom: 8px;

    &::before {
      content: '✓';
      position: absolute;
      left: 0;
      color: var(--success-color);
      font-weight: bold;
    }
  }
}

.scenario-image {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.placeholder-thumb {
  width: 280px;
  height: 200px;
  border-radius: var(--radius-lg);
  display: flex;
  align-items: center;
  justify-content: center;

  i {
    font-size: 64px;
    color: rgba(255, 255, 255, 0.8);
  }
}

/* 路线图时间轴 */
.roadmap-section {
  padding: 100px 0;
  background-color: var(--bg-page);
}

.timeline {
  position: relative;
  max-width: 1000px;
  margin: 0 auto;

  &::before {
    content: '';
    position: absolute;
    left: 50%;
    top: 0;
    bottom: 0;
    width: 2px;
    background-color: var(--border-color);
    transform: translateX(-50%);
  }
}

.timeline-item {
  position: relative;
  margin-bottom: 40px;
}

.timeline-dot {
  position: absolute;
  width: 16px;
  height: 16px;
  background-color: var(--primary-color);
  border-radius: 50%;
  left: 50%;
  top: 20px;
  transform: translateX(-50%);
  z-index: 1;
  border: 4px solid var(--bg-card);
  box-shadow: 0 0 0 2px var(--primary-color);
}

.timeline-content {
  width: calc(50% - 30px);
  background-color: var(--bg-card);
  padding: 20px 30px;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  position: relative;

  &.left {
    margin-right: auto;
  }

  &.right {
    margin-left: auto;
  }
}

.timeline-date {
  font-size: 14px;
  color: var(--primary-color);
  font-weight: 600;
  margin-bottom: 8px;
}

.timeline-title {
  font-size: 20px;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 10px;
}

.timeline-desc {
  font-size: 14px;
  color: var(--text-secondary);
  line-height: 1.7;
  margin: 0;
}

/* CTA区 */
.cta-section {
  padding: 80px 0;
  background: linear-gradient(135deg, var(--primary-color) 0%, #764ba2 100%);
  text-align: center;
}

.cta-title {
  font-size: 36px;
  font-weight: bold;
  color: var(--bg-card);
  margin: 0 0 16px;
  text-transform: capitalize;
}

.cta-desc {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.8);
  margin: 0 0 40px;
}

.cta-buttons {
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
}

.cta-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 14px 36px;
  font-size: 16px;
  border-radius: 30px;
  text-decoration: none;
  font-weight: 500;
  transition: transform 0.3s, box-shadow 0.3s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  &.docs {
    background-color: var(--bg-card);
    color: var(--primary-color);
  }

  &.contact {
    background-color: transparent;
    color: var(--bg-card);
    border: 2px solid rgba(255, 255, 255, 0.6);
  }
}

/* 底部Footer */
.home-footer {
  background-color: #1a1c20;
  color: var(--bg-card);
  padding: 60px 0 20px;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 40px;
  margin-bottom: 40px;
}

.footer-info {
  h3 {
    font-size: 24px;
    margin: 0 0 10px;
  }

  p {
    color: var(--text-muted);
    margin: 0;
  }
}

.footer-links {
  display: flex;
  gap: 60px;
  flex-wrap: wrap;
}

.link-group {
  h4 {
    font-size: 16px;
    margin: 0 0 16px;
    color: var(--bg-card);
  }

  a {
    display: block;
    color: var(--text-muted);
    text-decoration: none;
    margin-bottom: 10px;
    transition: color 0.3s;

    &:hover {
      color: var(--primary-color);
    }
  }
}

.footer-bottom {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid var(--text-secondary);
  color: var(--text-muted);
  font-size: 14px;

  p {
    margin: 5px 0;
  }
}

/* 响应式适配移动端 */
@media screen and (max-width: 768px) {
  .product-name {
    font-size: 40px;
  }

  .slogan {
    font-size: 20px;
  }

  .hero-section .container {
    flex-direction: column;
    text-align: center;
  }

  .hero-content {
    padding-right: 0;
    margin-bottom: 40px;
  }

  .hero-buttons {
    justify-content: center;
  }

  .features-section,
  .scenarios-section,
  .roadmap-section {
    padding: 50px 0;
  }

  .section-title {
    font-size: 28px;
    margin-bottom: 40px;
  }

  .scenario-item {
    flex-direction: column;

    &.left .scenario-content,
    &.left .scenario-image,
    &.right .scenario-content,
    &.right .scenario-image {
      order: initial;
    }
  }

  .placeholder-thumb {
    width: 100%;
    max-width: 280px;
  }

  .timeline {
    &::before {
      left: 20px;
    }
  }

  .timeline-dot {
    left: 20px;
  }

  .timeline-content {
    width: calc(100% - 50px);
    margin-left: auto !important;
    margin-right: 0 !important;
  }

  .footer-content {
    flex-direction: column;
    gap: 30px;
  }

  .footer-links {
    gap: 30px;
  }

  .cta-title {
    font-size: 28px;
  }
}
</style>